import { action, makeObservable, observable } from 'mobx';
import { BaseAddEditViewModel } from '../../../../core/services/BaseViewModel';
import { Appl } from '../../../../core/Appl';
import { Service } from 'typedi';
import { SpcModel } from './SpcModel';
import { ISpcService } from '../SpcService';

@Service() // eslint-disable-next-line
export default class SpcViewModel extends BaseAddEditViewModel {

    private service: ISpcService;
    @observable public model: SpcModel = {
        guId: '',
        firstName: '',
        lastName: '',
        middleInitial: '',
        email: '',
    };

    constructor() {
        super('SCERS Member Portal');
        this.service = Appl.Services.get<ISpcService>('ISpcService');
        makeObservable(this);
    }

    @action
    public async getFormattedUrlAsync(): Promise<string> {
        let url = '';
        Appl.Validator.init();
        await Appl.Validator.validateString('Member GUID', 'guId', this.model.guId, true, 40);
        if (Appl.Validator.isValid()) {
            this.model.firstName = "FName";
            this.model.lastName = "LName";
            this.model.email = `${this.model.guId}@scers.com`;
            const result = await this.service.getUrl(this.model);
            if (result.success) {
                url = result.data;
                window.open(`${url}`)
                return url;
            } else {
                Appl.Error.handle(result.error);
            }
        }
        return '';
    }

}
